import { Logo } from "./Logo";
import { BUSINESS } from "../lib/constants";
import { Phone, Mail, MapPin, Zap, Star } from "lucide-react";

export default function Footer() {
  return (
    <footer id="contact" className="relative border-t border-white/10 bg-ink/60 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 pt-16 pb-0">
        <div
          className="font-display italic text-[11vw] lg:text-[9vw] leading-[0.9] text-outline opacity-50 select-none whitespace-nowrap"
          aria-hidden="true"
          data-testid="footer-wordmark"
        >
          Everything Works
        </div>

        <div className="py-14 grid md:grid-cols-[1.4fr_1fr_1fr] gap-12 border-t border-white/10 mt-4">
          <div>
            <Logo />
            <p className="mt-6 max-w-sm text-mist text-sm leading-relaxed">
              Ultra-clear window cleaning for homes and storefronts in
              Naperville, Illinois. Locally owned, one pane at a time.
            </p>
            <div className="mt-6 inline-flex items-center gap-2 rounded-full border border-crystal/40 bg-crystal/10 px-4 py-2">
              <Zap size={13} className="text-crystal" />
              <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-crystal">
                Zelle accepted
              </span>
            </div>
          </div>

          <div>
            <h4 className="font-mono text-[11px] tracking-[0.3em] uppercase text-mist mb-5">Reach us</h4>
            <ul className="space-y-4 text-sm">
              <li>
                <a href={BUSINESS.phoneHref} data-testid="footer-phone-link" className="flex items-center gap-3 text-white/90 hover:text-crystal transition-colors duration-200">
                  <Phone size={15} className="text-crystal" /> {BUSINESS.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${BUSINESS.zelleEmail}`} data-testid="footer-email-link" className="flex items-center gap-3 text-white/90 hover:text-crystal transition-colors duration-200 break-all">
                  <Mail size={15} className="text-crystal shrink-0" /> {BUSINESS.zelleEmail}
                </a>
              </li>
              <li className="flex items-center gap-3 text-mist">
                <MapPin size={15} className="text-crystal shrink-0" /> Naperville, IL &amp; surrounding areas
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-mono text-[11px] tracking-[0.3em] uppercase text-mist mb-5">Booking hours</h4>
            <p className="text-sm text-white/90">8:00 AM — 5:00 PM, daily</p>
            <p className="mt-3 text-sm text-mist">Arrival windows confirmed by text.</p>
            <p className="mt-3 text-sm text-mist">Pay with Zelle to {BUSINESS.zellePhone}</p>
            <a
              href={BUSINESS.reviewUrl}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-review-link"
              className="mt-6 inline-flex items-center gap-2 rounded-full border border-crystal/40 px-5 py-2.5 font-mono text-[10px] tracking-[0.2em] uppercase text-crystal hover:bg-crystal hover:text-midnight transition-colors duration-200"
            >
              <Star size={12} /> Leave a Google review
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-6 flex flex-wrap items-center justify-between gap-3">
          <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-mist/60">
            © {new Date().getFullYear()} {BUSINESS.name}
          </span>
          <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-mist/60">
            Windows · Panes · Storefronts
          </span>
        </div>
      </div>
    </footer>
  );
}
